<template>
  <div class="screenfull-wrapper">
    <a-tooltip placement="bottom">
      <template v-slot:title>
        {{ isFullscreen ? '退出全屏' : '切为全屏' }}
      </template>
      <FullscreenExitOutlined
        v-if="isFullscreen"
        @click="click"
        :style="{ fontSize: '20px', cursor: 'pointer' }"
      />
      <FullscreenOutlined
        v-else
        @click="click"
        :style="{ fontSize: '20px', cursor: 'pointer' }"
      />
    </a-tooltip>
    <img :src="getNoticeImageUrl()" alt="notice" class="notice-image" />
  </div>
</template>

<script>
import screenfull from 'screenfull'
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons-vue'

export default {
  name: 'Screenfull',
  components: {
    FullscreenOutlined,
    FullscreenExitOutlined,
  },
  data() {
    return {
      isFullscreen: false,
      // 通知图片
      noticeImage: require('@/assets/notice.png'),
    }
  },
  mounted() {
    this.init()
  },
  beforeUnmount() {
    this.destroy()
  },
  methods: {
    click() {
      if (!screenfull.isEnabled) {
        this.$message.warning('你的浏览器不支持全屏')
        return false
      }
      screenfull.toggle()
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
    },
    // 获取通知图片的 URL
    getNoticeImageUrl() {
      const noticeImage = this.noticeImage
      if (noticeImage && typeof noticeImage === 'object' && noticeImage.default) {
        return noticeImage.default
      }
      if (typeof noticeImage === 'string') {
        return noticeImage
      }
      // 如果是对象，尝试转换为字符串
      if (noticeImage) {
        return String(noticeImage)
      }
      return ''
    },
  },
}
</script>

<style lang="less" scoped>
.screenfull-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.notice-image {
  width: 24px;
  height: 24px;
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
  object-fit: contain;
  flex-shrink: 0;
}
</style>
